const config = require('./config.yaml');
if ($('.js-top-nav').data('template') === 'horizontal-content') {
	function menuTopBuild() {
		$('.js-top-item-lvl2').has('.js-top-list-lvl3').addClass('has-submenu');
		$('.js-top-item-lvl3').has('.js-top-list-lvl4').addClass('has-submenu');
	}
	if (config.hoverable) {
		var hideEvents = 'mouseover touchstart';
		var openEvents = 'click touchstart mouseenter';
	} else {
		var hideEvents = 'click touchstart';
		var openEvents = 'click touchstart';
	}
	if ($.fn.velocity) {
		$('.js-top-link.js-top-link-lvl1').on(openEvents, function (event) {
			var $this = $(this),
				lvl = 1;
			if ($this.hasClass('js-top-link-lvl2')) {
				lvl = 2;
			} else if ($this.hasClass('js-top-link-lvl3')) {
				lvl = 3;
			} else if ($this.hasClass('js-top-link-lvl4')) {
				lvl = 4;
			}
			openTopMenu ($this, lvl, event);
		});
		function openTopMenu(element, lvl, event) {
			var $this = element;
			var showEffect = 'transition.slideDownIn';
			if (!$this.hasClass('is-expand') && $this.parents('.js-top-item-lvl' + lvl).has('.js-top-list-lvl' + (lvl + 1)).length) {
				event.preventDefault();
				$('.js-top-link-lvl' + lvl + '.is-expand')
					.removeClass('is-expand')
					.siblings('.js-sub-space, .nav__list')
					.velocity('transition.fadeOut', 200)
					.find('.is-expand')
					.removeClass('is-expand')
					.siblings('.nav__list')
					.velocity('transition.fadeOut');
				$this
					.addClass('is-expand')
					.siblings('.js-sub-space, .nav__list')
					.velocity(showEffect, 200);
			} else if (config.hoverable) {
				$this.parent()
					.siblings()
					.find('.is-expand')
					.removeClass('is-expand')
					.siblings('.nav__list')
					.velocity('transition.slideUpOut', 200);
			}
			$this.parents('.js-sub-space').height('auto');
			var	thisListHeight = $this.parents('.nav__list').height(),
				childListHeight = $this.siblings('.nav__list').height();
			if (thisListHeight < childListHeight) {
				$this.parents('.js-sub-space').velocity({height: childListHeight}, 200);
			} else {
				$this.parents('.js-sub-space').velocity({height: thisListHeight}, 200);
			}
		}

		$(document).on(hideEvents, function (event) {
			if (!$(event.target).closest('.js-top-list-lvl1').length) {
				closeMenu();
			}
		});

		$('.js-sub-close').on('click', closeMenu);

		function closeMenu() {
			$('.js-top-nav .is-expand')
				.removeClass('is-expand')
				.siblings('.js-sub-space, .js-sub-space .nav__list')
				.velocity('transition.slideUpOut', 200);
			$('.js-sub-space').height('auto');
			$('.nav__overlay')
				.removeClass('is-expand')
				.velocity('fadeOut', 200);
			$('.js-top-list-lvl1').removeClass('is-expand');
		}
	} else {
		console.error('Menu: Для работы меню необходимо подключить VelocityJS и VelocityJS UI Pack');
	}

	/**
	 * Метод проверяет, нужно ли фиксировать верхнее меню
	 * Основывается на том, проскролил ли пользователь строку меню
	 * @param $menu - блок, который нужно проверить
	 */
	function isNeedFixedTopMenu($menu, startOffset = 0) {
		return $menu
			&& $menu.length
			&& ($(window).scrollTop() >= startOffset);
	}

	/**
	 * Зафиксировать верхнее меню сверху при прокрутке
	 * @param $menu - блок, который нужно зафиксировать
	 */
	function fixedTopMenu($menu) {
		if ($menu && $menu.length) {
			//вешаем класс фиксации
			$menu.addClass('is-fixed');
		}
	}

	/**
	 * Снять фиксацию верхнего меню при прокрутке
	 * @param $menu - блок, с которого нужно снять фиксацию
	 */
	function unfixedTopMenu($menu) {
		if ($menu && $menu.length) {
			// снимаем класс фиксации
			$menu.removeClass('is-fixed');
		}
	}

	const $lineMenu = $('.js-header-top-nav');
	const defaultLineMenuTop = $lineMenu.offset().top;

	$(window).scroll(function () {
		//Проверяем, нужно ли фиксировать верхнее меню
		if (isNeedFixedTopMenu($lineMenu, defaultLineMenuTop)) {
			//Если нужно - фиксируем
			if (!$lineMenu.hasClass('is-fixed')) {
				fixedTopMenu($lineMenu);
			}
		} else {
			//Иначе снимаем фикс
			unfixedTopMenu($lineMenu);
		}
	});

	menuTopBuild();
}



// WEBPACK FOOTER //
// ./temp/components/menu/horizontal-content-nornikel/index.js